import React from 'react';
import PropTypes from 'prop-types';

var styles$1 = {"cell":"JTr0N","header":"wyLeB","selected":"kgExF","editing":"_1KqOm","singleSelection":"PQ2W8","hideLastBlock":"_8rJow","editorWrapper":"_2ZI13","viewerWrapper":"Y6jkt","hideFirstBlock":"Bxd6d","editor":"Vf8n5","edit":"IvLdX","view":"IZw9w","editingToolbarWrapper":"d4Svh","selectAll":"VZ-cj","disableSelection":"_1JrBY"};

var styles = {"borderT":"OkGrS","borderB":"P-xDX","borderL":"_8hkjQ","borderR":"ETCvT"};

var CellBorders = function CellBorders(_ref) {
  var borders = _ref.borders;
  return [(borders == null ? void 0 : borders.top) && /* @__PURE__ */React.createElement("div", {
    key: "top",
    style: {
      background: borders.top
    },
    className: styles.borderT
  }), (borders == null ? void 0 : borders.bottom) && /* @__PURE__ */React.createElement("div", {
    key: "bottom",
    style: {
      background: borders.bottom
    },
    className: styles.borderB
  }), (borders == null ? void 0 : borders.right) && /* @__PURE__ */React.createElement("div", {
    key: "right",
    style: {
      background: borders.right
    },
    className: styles.borderR
  }), (borders == null ? void 0 : borders.left) && /* @__PURE__ */React.createElement("div", {
    key: "left",
    style: {
      background: borders.left
    },
    className: styles.borderL
  })];
};
CellBorders.propTypes = {
  borders: PropTypes.object
};

export { CellBorders as C, styles$1 as s };

import 'wix-rich-content-plugin-table/dist/loadable/viewer/es/styles.viewer.min.global.css'